import React from 'react'
import NewBlogPageHero from './NewBlogPageHero'
import Blogs from './Blogs'


const NewBlogPage = () => {
  return (
    <div>
      <NewBlogPageHero />
      <Blogs/>
    </div>
  )
}

export default NewBlogPage